import type { Recommendation } from '../../data/schemas';
import type { SeverityId } from '../../types/ids';
import type { DetectedTension } from '../../types/result';

const SEVERITY_LABEL: Record<SeverityId, string> = {
  notice: 'Hinweis',
  important: 'Wichtiger Reibungspunkt',
  critical: 'Zentrale Voraussetzung ungeklärt',
};

interface TensionCardProps {
  tension: DetectedTension;
  recommendations: readonly Recommendation[];
}

/** Spannungsfeld-Card (Abschnitt 17.6/17.7). Kein Punktabzug, sondern ein eigenständiger Befund. */
export function TensionCard({ tension, recommendations }: TensionCardProps) {
  const linkedRecommendations = tension.recommendationIds
    .map((id) => recommendations.find((r) => r.id === id))
    .filter((r): r is Recommendation => !!r);

  return (
    <article className={`card tension-card tension-card--${tension.severity}`}>
      <p className={`pill pill--${tension.severity}`}>
        Spannungsfeld · {SEVERITY_LABEL[tension.severity]}
      </p>
      <h3>{tension.title}</h3>
      <p>{tension.summary}</p>
      <p>
        <strong>Warum das wichtig ist:</strong> {tension.explanation}
      </p>
      {tension.businessImpact && (
        <p>
          <strong>Geschäftliche Auswirkung:</strong> {tension.businessImpact}
        </p>
      )}
      {tension.personalImpact && (
        <p>
          <strong>Persönliche Auswirkung:</strong> {tension.personalImpact}
        </p>
      )}
      {linkedRecommendations.length > 0 && (
        <div>
          <p>
            <strong>Passende Handlungsschritte</strong>
          </p>
          <ul>
            {linkedRecommendations.map((recommendation) => (
              <li key={recommendation.id}>{recommendation.title}</li>
            ))}
          </ul>
        </div>
      )}
    </article>
  );
}
